import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HandymanIcon(props: IconProps) {
    return <Icon {...props} iconKey={"handyman"}/>
}
